import {type MutationTree} from 'vuex';

const mutations: MutationTree<EnrolmentApplicationState> = {
    update(state, payload)
    {
        state.error = null;

        for (let key in payload)
        {
            if (payload.hasOwnProperty(key))
            {
                state[key] = payload[key];
            }
        }
    },
    inject(state, payload)
    {
        state.error = null;

        let inject = function(state: EnrolmentApplicationState, payload: any)
        {
            for (let key in payload)
            {
                if (payload.hasOwnProperty(key))
                {
                    if (payload[key] !== null && typeof payload[key] === 'object')
                    {
                        if (typeof state[key] === 'undefined')
                        {
                            state[key] = Array.isArray(payload[key]) ? [] : {};
                        }

                        inject(state[key], payload[key]);
                    }
                    else
                    {
                        state[key] = payload[key];
                    }
                }
            }
        };

        inject(state, payload);
    },
    callback(state, callback)
    {
        state.error = null;

        callback(state);
    },
};

export default mutations;